import { Box } from "@mui/material";

export function KioskIcon() {
  return (
    <Box
      component="span"
      className="MuiSvgIcon-root"
      sx={{
        display: "inline-block",
        width: "1em",
        height: "1em",
        backgroundColor: "currentColor",
        mask: "url(/images/icons/mui-custom/device_in_aisle.svg) center / contain no-repeat",
        WebkitMask: "url(/images/icons/mui-custom/device_in_aisle.svg) center / contain no-repeat",
      }}
    />
  );
}
